/** Pure exponential-backoff math, lifted 2026-09-02 from `utils/async/backoff-core.ts` at that leaf's UTILS_MAX_LINES utils
 *  cap (`QUAL-FILE-SIZE-CAP-HEADROOM-TIGHT-001`); the retry combinator and the transient-error classifiers stay there. */

import { DEFAULT_BACKOFF_JITTER_MAX_MS } from './retry-backoff.ts';
import { DEFAULT_BACKOFF_MULTIPLIER } from './timing.ts';
import type { RetryConfig } from '@federa/types/api-response';

/** @runtime-derived-ssot-helper (const-leaf-pinned): `attempt` is 0-indexed. */
export function calculateBackoff(attempt: number, config: RetryConfig): number {
	const multiplier = config.backoffMultiplier ?? DEFAULT_BACKOFF_MULTIPLIER;
	const cappedAttempt = config.exponentCap !== undefined ? Math.min(attempt, config.exponentCap) : attempt;
	const backoffDelay = config.baseDelayMs * multiplier ** cappedAttempt;
	return Math.min(backoffDelay, config.maxDelayMs);
}

/**
 * Jitter prevents a thundering herd on mass reconnection. INTENTIONAL: `Math.random` is acceptable here (non-security use).
 * @runtime-derived-ssot-helper (const-leaf-pinned): Jitter prevents a thundering herd on mass reconnection.
 */
export function calculateBackoffWithJitter(attempt: number, config: RetryConfig): number {
	const baseDelay = calculateBackoff(attempt, config);
	return baseDelay + Math.random() * DEFAULT_BACKOFF_JITTER_MAX_MS;
}
